export default __webpack_public_path__ + "static/media/LineLogo.7577bb5c.png";